import {Component, OnInit, Renderer2} from "@angular/core";
import {catchError, finalize, of, Subject, takeUntil} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {AppService} from "@services/app.service";
import {Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {ConfigService} from "@services/configService";
import {LoggingService} from "@services/logging.service";
import {User} from "@pages/modal/user/user";
import {UserContextService} from "@services/user-service/usercontext.service";

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
})

export class UserListComponent implements OnInit {
    destroy$: Subject<boolean> = new Subject<boolean>();
    userDetails: User[] = [];
    shopOwnerDetails: User[] = [];
    searchText: string = "";


    constructor(
        private renderer: Renderer2,
        private toastr: ToastrService,
        private appService: AppService,
        private router: Router,
        private spinner: NgxSpinnerService,
        private configService: ConfigService,
        private loggingService: LoggingService,
        private userContextService: UserContextService
    ) {

    }


    ngOnInit() {
        this.getAllUserDetails();
    }


    //get all MYKADAI Shop owner details by ADMIN
    getAllUserDetails() {
        this.spinner.show();
        this.appService.getAllShopOwnerList()
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.spinner.hide()),
                catchError((error: any) => {
                    console.error('Error fetching shop owner details:', error);
                    this.toastr.error('Failed to load user details. Please try again later.', 'Error');
                    return of(null); // Return a safe observable to prevent breaking the stream
                })
            )
            .subscribe((userDetails) => {
                if (userDetails) {
                    this.userDetails = userDetails;
                    this.shopOwnerDetails = this.userDetails.sort((a, b) => b.userID - a.userID).filter(user => user.appCode == "MYKADAI");
                    this.loggingService.log('shop owner details list::', this.shopOwnerDetails);
                } else {
                    this.toastr.info('No users found', 'Users')
                }
            })
    }


    //Approval status sanitize word function
    getApprovalStatusText(status: string): string {
        return status === 'APPROVED' ? 'Approved' : 'Not Approved';
    }


    //view function
    viewProfile(userId: number) {
        this.userContextService.setUserId(userId);
        this.router.navigate(['/main/user-profile']);
    }
}